import './Recaptcha.scoped.scss';
import { useCallback, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import i18n from 'src/i18n';

export const useRecaptcha = (): {
  token: string;
  reset: () => void;
  Recaptcha: JSX.Element;
} => {
  const [token, setToken] = useState<string>('');
  const ref = useRef<any>();
  const onChange = useCallback(
    (value: string | null) => {
      if (value && value.length) {
        setToken(value as string);
      }
    },
    [setToken],
  );

  const reset = useCallback(() => {
    setToken('');
    ref && ref.current && ref.current.reset();
  }, []);

  const onExpired = useCallback(() => {
    setToken('');
    ref && ref.current && ref.current.reset();
  }, []);

  return {
    token,
    reset,
    Recaptcha: (
      <div className="recaptcha-wrap">
        <ReCAPTCHA
          ref={ref}
          sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY as string}
          onChange={onChange}
          onExpired={onExpired}
          hl={i18n.languages[0]}
        />
      </div>
    ),
  };
};
